export default __webpack_public_path__ + "static/media/background-home.32ea4e00.jpg";